import { render, staticRenderFns } from "./GuiaEnseñanza.vue?vue&type=template&id=49c69d00&"
import script from "./GuiaEnseñanza.vue?vue&type=script&lang=js&"
export * from "./GuiaEnseñanza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports